import { instance, endpoint, isMock, generator } from 'api'
import { mocker } from 'api/hres81x/mocker'

export default {
  getLabels () {
    if (isMock) return generator(mocker.labels())
    return instance().get(endpoint + '/hres81x/labels')
  },
  getIndex (searchParams) {
    if (isMock) return generator(mocker.index())
    const params = searchParams.period + '/' + searchParams.month + '/' + searchParams.year
    return instance().get(endpoint + '/hres81x/index/' + params)
  },
  getNumperiod (searchParams) {
    if (isMock) return generator(mocker.numperiod())
    const params = searchParams.month + '/' + searchParams.year
    return instance().get(endpoint + '/hres81x/numperiod/' + params)
  },
  postPrint ({ sendParams }) {
    if (isMock) return generator(mocker.print())
    return instance().post(endpoint + '/hres81x/print', sendParams)
  },
  postLogin ({ sendParams }) {
    if (isMock) return generator(mocker.login())
    return instance().post(endpoint + '/hres81x/login', sendParams)
  }
}



// WEBPACK FOOTER //
// ./src/api/hres81x/index.js